import { getArrayOfNLastYears } from "../../../../../../features/dataFunctions/generate/basic";
import { useMapDispatch } from "../../../../../../stateManagement/hooks/useMapDispatch";
import { MapName } from "../../../../../../stateManagement/reducers/maps/actions";
import { store } from "../../../../../../stateManagement/store";
import { ListRadioFilterValue, Preset } from "../types";

export function patchFilterListRadioState(
    mapName: MapName,
    fieldName: string,
    patch: any,
    dispatchMap: ReturnType<typeof useMapDispatch>,
) {
    const lowerFirstMapName = mapName[0].toLowerCase() + mapName.slice(1) as MapName
    const currentFilterState = store.getState().maps[lowerFirstMapName].mapFiltersState[fieldName];
    let patchForSend: any = {}
    if (!currentFilterState) return;

    // строится patchForSend */
    const { isIgnored, includeNull, searchValue, toggleValue } = patch ?? {}
    if ('isIgnored' in patch) patchForSend = { isIgnored }
    if ('includeNull' in patch) {
        patchForSend = { isIgnored: false, includeNull }
    }
    if ('searchValue' in patch) patchForSend = { searchValue }
    if ('toggleValue' in patch) {
        const { value, checked } = toggleValue;
        const values = currentFilterState.values.map((v: any) =>
            v.value === value ? { ...v, checked } : { ...v, checked: false },
        );
        patchForSend = { isIgnored: false, values }
    }

    dispatchMap(mapName, 'patchMapFiltersState', { fieldName, patch: patchForSend });
}

export function configureListRadioPresetValues(preset: Preset | undefined): ListRadioFilterValue[] {
    if (!preset) return [];
    const { type } = preset ?? {}
    if (type === "lastYears") {
        const { numberOfYears } = preset ?? {}
        const lastYears = getArrayOfNLastYears(numberOfYears)
        const values = lastYears.map((year: any) => ({
            caption: year,
            value: year,
            checked: false
        }));
        values[0].checked = true;
        return values
    }
    return []
}